import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { Link } from 'react-router-dom';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { ProductsElement } from '@/features/w/[identifier]/setting/products/{components}/ProductsElement';

export const WorkspaceProducts = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('売上カテゴリ設定'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { _w_, me } = useCurrentWorkspace();

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'product'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">売上カテゴリ一覧</h5>
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  {me!.admin && (
                    <Link
                      to={`/w/${_w_!.identifier}/setting/products/new`}
                      className="btn bg-gradient-primary btn-icon"
                    >
                      {' '}
                      <i className="fas fa-plus"></i>新規売上カテゴリ登録
                    </Link>
                  )}
                </div>
              </div>

              <ProductsElement />
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
